/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access */
import { getLangFallbackUrl } from '~/lang/utils/langfetch'
import { ChangePasswordErrors } from './types'
import { csrfTokenService } from '../csrf/CsrfTokenService'

type Error = string[]

interface ResponseErrors {
  oldpassword?: Error
  password1?: Error
  non_field_errors?: Error
}

export class ChangeUserPasswordRepositoryFetch {
  async change(currentPassword: string, newPassword: string): Promise<void> {
    try {
      return await this.getResponse(currentPassword, newPassword)
    } catch (error) {
      const { status, data } = error as any
      if (status !== 200) {
        if (data.errors) {
          // eslint-disable-next-line no-throw-literal -- TODO: Type the error response from Django API; throwing object is intentional for XState error handling
          throw { errors: this.mapErrors(data.errors) }
        }
      }
    }
  }

  private getFormData(currentPassword: string, newPassword: string) {
    const formData = new FormData()
    formData.append('oldpassword', currentPassword)
    formData.append('password1', newPassword)
    formData.append('password2', newPassword)
    return formData
  }

  private async getResponse(currentPassword: string, newPassword: string) {
    const { csrfToken } = await csrfTokenService()
    return $fetch(getLangFallbackUrl('en-gb', '/_/users/change-password/'), {
      method: 'POST',
      body: this.getFormData(currentPassword, newPassword),
      headers: {
        'X-ELDARION-AJAX': 'true',
        'X-CSRFToken': csrfToken,
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'include',
    })
  }

  private mapErrors(errors: ResponseErrors): ChangePasswordErrors {
    return {
      currentPassword: errors.oldpassword,
      newPassword: errors.password1,
      nonFieldErrors: errors.non_field_errors,
    }
  }
}
